import ReferralsActionTypes from './referrals-types'

const INITIAL_STATE = {
    loader: null,
    success: null,
    error: null,
    referrals: null,
    referralsStatus: null,
}

const referralsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ReferralsActionTypes.START_GET_REFERRALS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS: true },
            }
        case ReferralsActionTypes.SUCCESS_GET_REFERRALS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS: null },
                referrals: action.payload,
                error: null,
            }
        case ReferralsActionTypes.FINISH_GET_REFERRALS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS: null },
                referrals: null,
                error: null,
            }
        case ReferralsActionTypes.FAILURE_GET_REFERRALS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS: null },
                referrals: null,
                error: true,
            }

        case ReferralsActionTypes.START_GET_REFERRALS_STATUS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS_STATUS: true },
            }
        case ReferralsActionTypes.SUCCESS_GET_REFERRALS_STATUS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS_STATUS: null },
                referralsStatus: action.payload,
                error: null,
            }
        case ReferralsActionTypes.FINISH_GET_REFERRALS_STATUS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS_STATUS: null },
                referralsStatus: null,
                error: null,
            }
        case ReferralsActionTypes.FAILURE_GET_REFERRALS_STATUS:
            return {
                ...state,
                loader: { ...state.loader, GET_REFERRALS_STATUS: null },
                referralsStatus: null,
                error: true,
            }

        case ReferralsActionTypes.START_POST_REFERRALS_TRAFFIC:
            return {
                ...state,
                loader: { ...state.loader, POST_REFERRALS_TRAFFIC: true },
            }
        case ReferralsActionTypes.SUCCESS_POST_REFERRALS_TRAFFIC:
            return {
                ...state,
                loader: { ...state.loader, POST_REFERRALS_TRAFFIC: null },
                error: null,
            }
        case ReferralsActionTypes.FINISH_POST_REFERRALS_TRAFFIC:
            return {
                ...state,
                loader: { ...state.loader, POST_REFERRALS_TRAFFIC: null },
                error: null,
            }
        case ReferralsActionTypes.FAILURE_POST_REFERRALS_TRAFFIC:
            return {
                ...state,
                loader: { ...state.loader, POST_REFERRALS_TRAFFIC: null },
                error: true,
            }

        default:
            return state
    }
}

export default referralsReducer
